import "./App.css";
import { useSelector } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
// import AppWrapper from "../components/layout/Styles/index";
import Routes from "../routes";
function App() {
  return (
    <>
      <Router>
        {/* <AppWrapper> */}
        <Routes />
        {/* </AppWrapper> */}
      </Router>
    </>
  );
}

export default App;
